const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export default class ThreeInstance {
  private static instance: any;

  public static async get(): Promise<any> {
    if (ThreeInstance.instance == null) {
      while (ThreeInstance.instance == null) {
        await delay(250);
      }
      return ThreeInstance.instance;
    }
    return this.instance;
  }

  public static set(instance: any) {
    if (!instance) {
      throw new Error('Failed to setup ThreeJS');
    }
    this.instance = instance;
  }

  public static async setFromRuntime(instance: any) {
    if (instance.get() != null) {
      ThreeInstance.set(instance.get());
    } else {
      while (instance.get() == null) {
        await delay(250);
      }
      ThreeInstance.set(instance.get());
    }
  }
}
